module.exports = __webpack_public_path__ + "static/img/H6BAN1.fa850f3f.jpg";